<template>
  <div id="inner_form_bidmarket">           
    <div class="wrapper_headers"> 
      <span v-html='$t("login.login_to")'></span>
      <span v-html='$t("login.access_your_account")'></span>
    </div>

    <form role="form" id="bidmarket_form">
      <div class="summary-errors alert alert-danger alert-dismissible" v-show="(errors.length > 0)">
        <ul>
          <li v-for="err in errors">{{err}}</li>
        </ul>
      </div>
      <fieldset>
        <div class="form-group">
          <input class="form-control" v-bind:placeholder="$t('login.user_name')" name="email" type="email" v-model="model.username" autofocus>
        </div>
        <div class="form-group form-last">
          <input class="form-control" v-bind:placeholder="$t('login.password')" name="password" type="password" value="" v-model="model.password">
        </div>
        <spin-button id="btnLogin" :css-class="'btn btn-lg btn-login btn-block'" :button-text="$t('login.login')" :loading="isLoading" :loading-text="$t('login.login')" :onClick="login"></spin-button>

        <!-- Change this to a button or input when using this as a form -->
        <div class="forget_pass">
          <div v-on:click="handleChangeComponentView('forgot-password')" >{{$t('login.forgot_your_password')}}</div>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
  import AuthService from '@/services/AuthService';

   export default {
    name: 'sign-in',
    data() {
      return {
        show: false,
        model: {},
        errors: [],
        isLoading: false
      };
    },
    methods: {
      handleChangeComponentView(name){
        this.$emit('change-component-view', name);
      },
      login() {
        let t = this;
        t.isLoading = true;
        AuthService.login(this.model).then((r) => {
          window.location.href = '/client';
        }, (e) => {
          console.log(e.response);
          this.errors = [];
          if (e.response.data.modelState) {
            for (var key in e.response.data.modelState) {
              for (var i = 0; i < e.response.data.modelState[key].length; i++) {
                this.errors.push(e.response.data.modelState[key][i]);
              }
            }
          } else {
            this.errors.push(e.response.data.exceptionMessage);
          }
        }).finally(() => {
          t.isLoading = false;
        });
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/SignIn.vue